import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DeleteLetterTemplatesRequest = {
  letterTemplateId: number;
};

export type DeleteLetterTemplatesResponse = {};

export const deleteLetterTemplate = async (request: DeleteLetterTemplatesRequest) => {
  await executeApiRequest(
    () =>
      axios.delete("/lettertemplates", {
        params: {
          letterTemplateId: request.letterTemplateId
        }
      }),
    false
  );
};
